import { registerFlow } from '../../../core/flow-register';
import { makeFlow } from '..';
import { IRAAccountTypes } from '../../transfer-flows/loaders';

registerFlow(makeFlow('traditional', IRAAccountTypes.TRADITIONAL));
